import React from "react"

const ToggleIcon = ({ hideTopBar }: { hideTopBar: boolean }) => {
  const strokeColor = hideTopBar ? "lightgray" : "rgba(41, 179, 189, 0.6)"
  const strokeWidth = 1
  return (
    <svg
      width="40"
      height="80"
      viewBox="0 0 40 80"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      {/* Rectangle with rounded borders */}
      <rect
        x="5"
        y="5"
        width="20"
        height="20"
        rx="7"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill="white"
      />

      {/* Horizontal lines */}
      <line
        x1="8"
        y1="12"
        x2="22"
        y2="12"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <line
        x1="8"
        y1="16"
        x2="22"
        y2="16"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <line
        x1="8"
        y1="20"
        x2="22"
        y2="20"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default ToggleIcon
